// dependency-graph-ignore-file
import '@atlaskit/css-reset';
import { Buffer } from 'buffer';

import { GlobalPageLoadExperience } from '@atlassian/ufo';
import DatabaseFatalError from '@databases/frontend/DatabaseFatalError';
import { setupGlobalLoadExperienceTimings } from '@databases/frontend-metrics/timings';
import { IntlProviderWithMessages, useLocale } from '@databases/intl';
import { logFatalError } from '@databases/logs';
import { setBatchAdapter } from '@databases/utils/redux/redux';
import { serializeError } from '@databases/utils/utils';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { batch } from 'react-redux';

import '@databases/app-access/init';
import './store-tracking';
import { initSentry } from './sentry';
import AppWithBridgeData from './standalone/standalone-app-with-bridge-data';

window.Buffer = Buffer; // @atlaskit/media-viewer needs this polyfill to work

try {
  setupGlobalLoadExperienceTimings();
  GlobalPageLoadExperience.startPageLoad('pending', true, performance.now());

  initSentry();
  setBatchAdapter(batch);
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const root = createRoot(document.getElementById('app')!);
  root.render(<AppWithBridgeData />);
  // eslint-disable-next-line canvas/no-swallow-errors-in-catch
} catch (error) {
  let formattedError = undefined;
  if (error instanceof Error) {
    logFatalError(error);
    formattedError = serializeError(error);
    formattedError = {
      name: formattedError.name,
      message: formattedError.message,
      stack: formattedError.stack,
      code: formattedError.code,
    };
    GlobalPageLoadExperience.failure({
      metadata: { error: formattedError },
      force: true,
    });
    try {
      const ErrorApp = ({ error }: { error: Error }) => (
        <IntlProviderWithMessages locale={useLocale()}>
          <DatabaseFatalError error={error} />
        </IntlProviderWithMessages>
      );
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      createRoot(document.getElementById('app')!).render(<ErrorApp error={error} />);
      // eslint-disable-next-line canvas/no-swallow-errors-in-catch
    } catch (error2) {
      if (error2 instanceof Error) {
        logFatalError(error2);
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        document.getElementById('global-error')!.innerText = error.message;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        document.getElementById('global-error')!.style.display = '';
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        document.getElementById('app')!.style.display = 'none';
      }
    }
  }
}
